<template>
  <div class="pwc-survey-info">
    <div v-for="(item, index) in questionList" :key="item.key">
      <!-- <h2 class="question-label" :class="item.required ? 'question-label_required':''">{{ item.id + '. ' + item.label }}</h2> -->
      <!-- eslint-disable-next-line -->
      <h2 v-if="item.QuestionId&&item.QuestionId.endsWith('CLAUSE')" class="question-label" :class="item.required ? 'question-label_required':'question-label-norequired'" v-html="item.formatLabel" />
      <h2 v-else-if="!hiddenTitles.includes(item.type)" class="question-label" :class="item.required ? 'question-label_required':'question-label-norequired'">{{ item.label }}</h2>
      <h4 v-if="item.desc" class="question-desc">{{ item.desc }}</h4>
      <h1 v-if="item.type === 'text'" class="question-text">{{ formatText(item) }}</h1>
      <div v-if="(item.type === 'input' || item.type === 'textarea')">
        <div v-if="item.meta.dataType === 'phone'" class="field-phone">
          <van-field readonly clickable :value="item.meta.countryCode" :disabled="item.meta.disabled" class="van-question-text" style="width: 40%;margin-right:5px" placeholder="请选择" :right-icon="item.showPicker? 'arrow-up': 'arrow-down'" @click="() => {$set(item, 'showPicker', true)}" />
          <van-field v-model="formData[item.key]" class="van-question-text" :disabled="item.meta.disabled" :type="inputType[item.type]" :placeholder="item.meta.placeholder" @mousewheel.native.prevent @input="(val) => {validField(item, val); checkNextShow(item, index);checkPhone(item);}" @blur="checkIsSubmit(item)"/>
        </div>
        <van-field
          v-else-if="item.default === 'SCHOOL'"
          ref="school"
          v-model="formData[item.key]"
          class="van-question-text"
          :type="inputType[item.type]"
          :disabled="item.meta.disabled"
          :placeholder="item.meta.placeholder"
          @mousewheel.native.prevent
          @input="(val) => {checkNextShow(item, index); handleDebounceSchoolSearch(val)}"
          @focus="handleSchoolFocus"
          @blur="handleSchoolBlur"
        />
        <van-field v-else v-model="formData[item.key]" class="van-question-text" :type="inputType[item.type]" :disabled="item.meta.disabled" :placeholder="item.meta.placeholder" @mousewheel.native.prevent @input="(val) => {validField(item, val); checkNextShow(item, index)}" />
        <div v-if="showSchoolPane && item.default === 'SCHOOL'" class="pwc-school-pane">
          <!-- eslint-disable-next-line vue/no-v-html -->
          <div v-for="school in filteredSchoolList" :key="school" class="pwc-school-item" @click="handleSchoolSelect(school)" v-html="highlightKeyWord(school)" />
          <div v-if="filteredSchoolList.length === 0" class="pwc-school-item" style="color: #777;">no match</div>
        </div>
      </div>
      <van-stepper v-if="item.type === 'number'" v-model="formData[item.key]" :step="item.meta.step" input-width="80" disabled-input :max="item.meta.max" :min="item.meta.min" :disabled="item.meta.disabled" @mousewheel.native.prevent @change="(val) => {validField(item, val)}" />
      <van-checkbox-group v-if="item.type === 'checkbox'" v-model="formData[item.key]" :disabled="item.meta.disabled" @change="(val) => {validField(item, val);checkNextShow(item, index)}">
        <van-checkbox v-for="o in item.options" :key="o.value" :name="o.id" shape="square">{{ o.value }}</van-checkbox>
        <van-field v-if="formData[item.key]&&formData[item.key].find((item) => {return item.endsWith('Other')})" v-model="formData[item.key + 'Other']" class="van-question-text" :disabled="item.meta.disabled" :placeholder="'请输入'" @mousewheel.native.prevent @input="(val) => {validField(item, val); checkNextShow(item, index)}" />
        <p v-if="formData[item.key]&&formData[item.key].find((item) => {return item.endsWith('Other')})" class="error-msg" style="margin-bottom: 5px" :class="
          [item.key + 'Other']? 'active': ''">{{ validateMsg[item.key + 'Other'] }}</p>
      </van-checkbox-group>
      <van-checkbox-group v-if="item.type === 'checkboxInput'" v-model="formData[item.key]" :disabled="item.meta.disabled" @change="(val) => {validField(item, val);checkNextShow(item, index)}">
        <div v-for="o in item.options" :key="o.value" style="display:flex; flex-direction: column; margin-bottom: 0.2rem;">
          <van-checkbox :name="o.id" shape="square">{{ o.value }}</van-checkbox>
          <van-field v-if="formData[item.key]&&formData[item.key].includes(o.id)" v-model="formData[item.key + 'Input'][o.id]" class="van-question-text" placeholder="Input text" />
        </div>
      </van-checkbox-group>
      <div v-if="item.type === 'sorting'">
        <draggable tag="div" :list="item.options" v-bind="{group:{ name:'options'}, ghostClass: 'ghost', handle: '.drag-item'}" handle=".drag-item" @end="() => {sortingChange(item)}">
          <div v-for="(o, ind) in item.options" :key="ind" class="drag-item van-radio__label">
            <van-field v-if="o.id.endsWith('Other')" v-model="formData[item.key + 'Other']" size="mini" :disabled="item.meta.disabled" class="van-question-text mr-2" :placeholder="'请输入'" @mousewheel.native.prevent @input="(val) => {validField(item, val);}" />
            <span v-else>{{ o.value }}</span>
            <van-icon name="wap-nav" />
          </div>
        </draggable>
      </div>
      <van-radio-group v-if="item.type === 'radio'" v-model="formData[item.key]" :disabled="item.meta.disabled" @change="(val) => {validField(item, val); checkNextShow(item, index)}">
        <van-radio v-for="o in item.options" :key="o.value" :name="o.defaultId || o.id">{{ o.value }}</van-radio>
        <van-field v-if="formData[item.key]&&formData[item.key].endsWith('Other')" v-model="formData[item.key + 'Other']" :disabled="item.meta.disabled" class="van-question-text" :placeholder="'请输入'" @mousewheel.native.prevent @input="(val) => {validField(item, val); checkNextShow(item, index)}" />
        <p v-if="formData[item.key]&&formData[item.key].endsWith('Other')" class="error-msg" style="margin-bottom: 5px" :class="validate[item.key + 'Other']? 'active': ''">{{ validateMsg[item.key + 'Other'] }}</p>
      </van-radio-group>
      <van-field v-if="item.type === 'select'" readonly clickable :value="item.text" :disabled="item.meta.disabled" class="van-question-text" :right-icon="item.showPicker? 'arrow-up': 'arrow-down'" :placeholder="item.meta.placeholder" @click="() => {if (!item.meta.disabled) {$set(item, 'showPicker', true)} }" />
      <van-field v-if="item.type === 'select' && formData[item.key]&&formData[item.key].endsWith('Other')" v-model="formData[item.key + 'Other']" class="van-question-text" :disabled="item.meta.disabled" :placeholder="'请输入'" @mousewheel.native.prevent @input="(val) => {validField(item, val); checkNextShow(item, index)}" />
      <p v-if="item.type === 'select' && formData[item.key]&&formData[item.key].endsWith('Other')" class="error-msg" style="margin-bottom: 5px" :class="validate[item.key + 'Other']? 'active': ''">{{ validateMsg[item.key + 'Other'] }}</p>
      <van-popup v-model="item['showPicker']" position="bottom" @close="(val) => {checkNextShow(item, index)}">
        <van-picker show-toolbar :columns="item.options | formatOptions" confirm-button-text="确认" @cancel="$set(item, 'showPicker', false)" @confirm="(val) => { selectConfirm(val, item); validField(item, val);}" />
      </van-popup>
      <!-- <van-field v-if="formData[item.key + 'Other'] !== undefined" v-mode="formData[item.key + 'Other']" /> -->
      <div v-if="item.type === 'date'" class="date-time-input-wrap">
        <van-field v-model="formData[item.key]" :placeholder="item.meta.placeholder" class="van-question-text" right-icon="calender-o" readonly :disabled="item.meta.disabled" @click="() => {$set(item, 'showTime', true)}" />
        <van-popup v-model="item['showTime']" :label="item.label" position="bottom" :overlay="true" @close="(val) => {validField(item, val);checkNextShow(item, index)}">
          <van-datetime-picker v-model="currentDate" :type="item.meta.type" :min-date="minDate" :max-date="maxDate" @cancel="() => {$set(item, 'showTime', false)}" @confirm="(val) => {dateConfirm(val, item); $set(item, 'showTime', false)}" @change="(e) => {dateChange(e, item)}" />
        </van-popup>
      </div>
      <pwc-uploader v-if="(item.type === 'fileupload' || item.type === 'imgupload')"  @hasUpload="hasUpload" :hasfile-list="formData[item.key]" :delay="delay" :disabled="item.meta.disabled" :options="item" @selectedFile="() => {validField(item, null);checkNextShow(item, index)}" 
        @uploadOrDelete="(val) => {uploadOrDelete(val, item)}"   @uploaded="(val) => {uploaded(val, item)}"   @uploadFileList="uploadFileList" />
      <upload-imgs v-if="item.type === 'uploadImgs'" :hasfile-list="formData[item.key]" :delay="delay" :disabled="item.meta.disabled" :options="item" @selectedFile="() => {validField(item, null);checkNextShow(item, index)}" @uploaded="(val) => {uploaded(val, item);}" />
      <van-rate v-if="item.type === 'rate'" v-model="formData[item.key]" color="#d04a02" :count="item.meta.max" :disabled="item.meta.disabled" @change="(val) => {validField(item, val);checkNextShow(item, index)}" />
      <van-image v-if="item.type === 'image'" :width="item.meta.width" :height="item.meta.height" :class="'align-'+item.meta.position" :src="item.meta.defaultValue" fit="contain" />
      <!-- eslint-disable-next-line vue/no-v-html -->
      <p v-if="item.type === 'section'" class="section-text" v-html="toDetail(item)" />
      <p class="error-msg" :class="validate[item.key]? 'active': ''">{{ validateMsg[item.key] }}</p>
    </div>
    <div v-if="questionList.length>0 && !hiddenSubmitBtn" style="text-align: center">
      <van-button type="default" class="sumit-btn" block @click="submit">提&nbsp;&nbsp;交</van-button>
    </div>
  </div>
</template>

<script>
// import { upload } from '@/mixin/file'
import nextOne from '@/components/PwcDyForm/common'
import PwcUploader from '@/components/PwcUpload'
import PwcUploadImgs from '@/components/PwcUploadImgs'
import { formatDate } from '@/util/date'
import { mapActions, mapState } from 'vuex'
import Actions from '@/constants/action'
import Draggable from 'vuedraggable'
import { debounce } from 'throttle-debounce'
import {
  CellGroup,
  NavBar,
  Field,
  Radio,
  RadioGroup,
  Image,
  Checkbox,
  CheckboxGroup,
  Picker,
  Popup,
  DatetimePicker,
  Rate,
  Col,
  Row,
  Button,
  Stepper,
  Dialog,
  DropdownMenu,
  DropdownItem,
  Icon,
  Slider
} from 'vant'
const formatType = {
  date: 'yyyy-MM-dd',
  datetime: 'yyyy-MM-dd hh:mm:ss',
  'year-month': 'yyyy-MM'
}
export default {
  name: 'PwcDyFormMobile',
  components: {
    PwcUploader,
    [CellGroup.name]: CellGroup,
    [NavBar.name]: NavBar,
    [Field.name]: Field,
    [Radio.name]: Radio,
    [RadioGroup.name]: RadioGroup,
    [Image.name]: Image,
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
    [Picker.name]: Picker,
    [Popup.name]: Popup,
    [DatetimePicker.name]: DatetimePicker,
    [Rate.name]: Rate,
    [Row.name]: Row,
    [Col.name]: Col,
    [Button.name]: Button,
    [Stepper.name]: Stepper,
    [Dialog.name]: Dialog,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Icon.name]: Icon,
    [Slider.name]: Slider,
    Draggable,
    UploadImgs: PwcUploadImgs
  },
  props:{
      surveyType:{
        type: String,
        default: ''
      },
      surveyId:{
        type: String,
        default: ''
      }
  },
  filters: {
    formatOptions(options) {
      return options.map((item) => {
        return {
          text: item.value || `${item.name}( +${item.code} )`,
          id: item.code || item.id
        }
      })
    }
  },
  mixins: [nextOne],
  data() {
    return {
      minDate: new Date('1900-01-01'),
      maxDate: new Date('2030-12-31'),
      currentDate: new Date(),
      validate: {},
      validateMsg: {},
      inputType: {
        input: 'text',
        textarea: 'textarea'
      },
      verification: {
        phoneNo: '',
        contryCode: 0,
        verificationCode: ''
      },
      hiddenTitles: ['text', 'image', 'section', 'attachment'],
      showSchoolPane: false,
      filteredSchoolList: [],
      hasUploadFlag: true,
      fileList:[],
      isFileFlag: null
    }
  },
  computed: {
    tempFiles() {
      return this.$store.getters.tempFiles
    },
    ...mapState(['loading'])
    // canSubmit() {
    //   return
    // }
  },
  watch: {
        hasUploadFlag:{
         handler(val){
           this.$nextTick(()=>{
            const types = [
            'rate',
            'fileupload',
            'imgupload',
            'uploadImgs',
            'checkbox',
            'checkboxInput',
            'radio',
            'select'
          ]
          if(!val){
              this.questionList.forEach(item =>{
                    if (item.required && types.includes(item.type)) {
  
                     this.$set(this.validate, item.key, false)
                }
              })
          }
           })
         }
    },
    questionList: {
      handler(val) {
        // 必填项初始化验证
        this.validate = {}
        this.validateMsg = {}
        this.$nextTick(() => {
          val &&
            val.forEach((item) => {
              if (item.required) {
                this.$set(this.validate, item.key, false)
                if (item.type === 'input' || item.type === 'textarea') {
                  this.$set(this.validateMsg, item.key, '请输入此项')
                } else if (item.type === 'number') {
                  this.$set(this.validateMsg, item.key, '请添加')
                } else if (item.type === 'fileupload') {
                  this.$set(this.validateMsg, item.key, '请选择文件')
                } else if (item.type === 'imgupload' || item.type === 'uploadImgs') {
                  this.$set(this.validateMsg, item.key, '请选择图片')
                } else {
                  this.$set(this.validateMsg, item.key, '请选择此项')
                }
                if (item.type === 'radio' || item.type === 'select' || item.type === 'checkbox' || item.type === 'sorting') {
                  this.$set(this.validate, item.key + 'Other', false)
                  this.$set(this.validateMsg, item.key + 'Other', '请输入')
                }
              }
            })
        })
      },
      deep: true,
      immediate: true
    }
  },
  created() {
    this.handleDebounceSchoolSearch = debounce(200, this.handleSearchSchool)
  },
  methods: {
    ...mapActions({
      getVerifyCode: Actions.GET_VERIFY_CODE,
      saveTempSurvey: Actions.SAVE_TEMP_SURVEY
    }),
    hasUpload(val){
      this.hasUploadFlag = val
    },
    // 检查是否已经提交过报名
    checkIsSubmit(item){
      if(this.surveyType === 'EREG'){
        this.checkLeadIsRegistered({surveyId: this.surveyId, eventId: this.$route.query.id, phoneNumber: this.formData[item.key]}) 
      }
    },
    toUpper(val) {
      // 转化为大写
      if (typeof val === 'string') {
        return val.toUpperCase().startsWith('OTHER')
      }
    },
    selectConfirm(val, item) {
      this.$set(item, 'showPicker', false)
      if (item.meta.dataType === 'phone') {
        item.meta.countryCode = val.id
        this.$set(item, 'text', val.id)
        this.checkPhone(item)
      } else {
        this.$set(item, 'text', val.text)
        this.formData[item.key] = val.id
      }
    },
    dateChange(e, item) {
      const endTimeArr = e.getValues()
      const tempDate = `${endTimeArr[0]}/${endTimeArr[1]}/${endTimeArr[2]}`
      this.formData[item.key] = formatDate(tempDate, formatType[item.meta.type])
    },
    dateConfirm(val, item) {
      this.formData[item.key] = formatDate(val, formatType[item.meta.type])
    },
    uploadFileList(val, flag){
      this.fileList = val
      this.isFileFlag = flag
    },
    uploadOrDelete(val, item) {
      this.$set(this.formData, item.key, val)
    },
    submit() {
      this.validateForm()
      // validate 里不包含 true 才可以提交
      if (!Object.values(this.validate).includes(true)) {
        if( this.fileList){
          this.formData.files = this.fileList
        }
        this.$emit('submitForm', this.formData)
      }
    },
    handleSearchSchool() {
      const ret = []
      const schoolInfo = this.questionList.find(item => item.default === 'SCHOOL')
      if (!schoolInfo) {
        return
      }
      const key = this.formData[schoolInfo.key].toLowerCase()
      if (!key) {
        this.filteredSchoolList = []
        return
      }
      this.school_en =  this.reduceArr(this.school_en)
      this.school_zh =  this.reduceArr(this.school_zh)
      for (let i = 0; i < this.school_zh.length; i++) {
        const v = this.school_zh[i]
        if (v.includes(key)) {
          ret.push(v)
        }
      }
      if (ret.length === 0) {
        for (let i = 0; i < this.school_en.length; i++) {
          const v = this.school_en[i]
          if (v.toLowerCase().includes(key)) {
            ret.push(v)
          }
        }
      }
      this.filteredSchoolList = ret.slice(0, 50)
    },
    handleSchoolFocus() {
      const schoolInfo = this.questionList.find(item => item.default === 'SCHOOL')
      if (!schoolInfo) {
        return
      }
      this.$set(this.validateMsg, schoolInfo.key, '')
      this.showSchoolPane = true
      const timer = setTimeout(() => {
        const rect = this.$refs.school[0].$el.getBoundingClientRect()
        const scrollY = document.querySelector('.pwc-app-container').scrollTop
        document.querySelector('.pwc-app-container').scrollTo({
          top: rect.top + scrollY - 50,
          behavior: 'smooth'
        })
        clearTimeout(timer)
      }, 200)
    },
    handleSchoolBlur() {
      const schoolInfo = this.questionList.find(item => item.default === 'SCHOOL')
      if (!schoolInfo) {
        return
      }
      const timer = setTimeout(() => {
        this.showSchoolPane = false
        this.validField(schoolInfo, this.formData[schoolInfo.key])
        clearTimeout(timer)
      }, 200)
    },
    handleSchoolSelect(v) {
      const schoolInfo = this.questionList.find(item => item.default === 'SCHOOL')
      if (!schoolInfo) {
        return
      }
      this.formData[schoolInfo.key] = v
      this.handleSearchSchool(v)
    },
    highlightKeyWord(word) {
      const schoolInfo = this.questionList.find(item => item.default === 'SCHOOL')
      if (!schoolInfo) {
        return
      }
      const key = this.formData[schoolInfo.key]
      const reg = new RegExp(`${key}`, 'i')
      const regResult = reg.exec(word)
      if (regResult && regResult.length > 0 && regResult[0]) {
        return word.replace(regResult[0], `<span style="color: #d04a02;">${regResult[0]}</span>`)
      }

      return word.replace(key, `<span style="color: #d04a02;">${key}</span>`)
    }
  }
}
</script>

<style lang="scss" scoped>
.pwc-school-pane {
  max-height: 20vh;
  background-color: #fff;
  overflow-y: scroll;
  padding: 12px;
}
.pwc-school-item {
  position: relative;
  line-height: 44px;
  font-size: 16px;
  text-align: left;
  &:after {
    position: absolute;
    box-sizing: border-box;
    content: ' ';
    pointer-events: none;
    top: -50%;
    right: -50%;
    bottom: -50%;
    left: -50%;
    border-bottom: 1px solid #ebedf0;
    transform: scale(0.5);
  }
}
</style>

<style lang="scss">
.pwc-form-privacy {
  font-family: 'Microsoft YaHei' !important;
  text-align: center;
  font-size: 16px;
  padding-top: 30px;
  padding-bottom: 15px;
  background-color: #fff;
  max-width: 640px;
  margin: auto;
  height: auto;
  width: auto;
  overflow: hidden;
}
.pwc-survey-info {
  .survey-container {
    position: relative;
    background-color: #fafafa !important;
    font-family: Arial, Helvetica, sans-serif, 'Microsoft YaHei' !important;
    padding: 20px;

    .logo {
      width: 100%;
      margin: 0px auto;
      padding: 50px;
    }

    .survey-label-container {
      .survey-title {
        font-size: 18px;
        padding: 10px 0;
        font-weight: normal;
        text-align: center;
      }
    }
  }
}

.drag-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 1px dotted #ccc;
  padding: 5px;
  margin: 5px;
}
.custom-button {
  width: 26px;
  color: #fff;
  font-size: 10px;
  line-height: 18px;
  text-align: center;
  background-color: #ee0a24;
  border-radius: 100px;
}
.van-checkbox {
  overflow: visible;
}

.van-checkbox__icon,
.van-radio__icon {
  align-self: start;
  margin-top: 5px;
}

.van-question-text {
  background-color: #fff;
  border: 1px solid #ccc;
  border-radius: 3px;
  padding: 8px 12px;
}

.pwc-survey-info .van-field--disabled {
  background-color: #eee;
}

.van-radio__label,
.van-checkbox__label {
  font-size: 14px;
  line-height: 1.6em;
  margin: 5px;
}

.question-label {
  margin: 0;
  padding: 10px 0 10px 5px;
  color: #777;
  font-weight: normal;
  font-size: 16px;
  line-height: 20px;
}
.question-desc {
  font-size: 14px;
  line-height: 16px;
  color: rgb(69, 90, 100);
  font-weight: normal;
  margin-bottom: 5px;
}
.question-text {
  font-size: 18px;
  font-weight: 500;
  line-height: 20px;
  color: rgb(69, 90, 100);
  margin-bottom: 6px;
}
.section-text {
  font-size: 16px;
  font-weight: 400;
  line-height: 26px;
  color: rgb(69, 90, 100);
  margin-bottom: 6px;
}

.question-label_required::before {
  position: absolute;
  left: 15px;
  color: #d04a02;
  font-size: 14px;
  content: '*';
}

.question-label-norequired {
  position: relative;
  left: -10px;
}

.sumit-btn {
  width: 100%;
  background-color: #d04a02;
  color: #fff;
}
.error-msg {
  font-size: 12px;
  color: #d04a02;
  margin-left: 10px;
  margin-bottom: 5px;
  visibility: hidden;
  -webkit-animation-name: fadeIn; /*动画名称*/
  -webkit-animation-duration: 0.5s; /*动画持续时间*/
  -webkit-animation-iteration-count: 1; /*动画次数*/
  -webkit-animation-delay: 0s; /*延迟时间*/
}
.active {
  visibility: visible;
}

.pwc-dialog-submit {
  padding: 22px;
  padding-top: 36px;
  padding-bottom: 6px;
}
.field-phone {
  display: flex;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
  margin: 0;
}
@-webkit-keyframes fadeIn {
  0% {
    opacity: 0; /*初始状态 透明度为0*/
  }
  50% {
    opacity: 0; /*中间状态 透明度为0*/
  }
  100% {
    opacity: 1; /*结尾状态 透明度为1*/
  }
}
.pwc-survey-info .van-image {
  max-width: 100%;
}
.pwc-survey-info .align-center {
  margin-left: auto;
  margin-right: auto;
}
.pwc-survey-info .align-right {
  margin-left: auto;
}
</style>
